<template>
<div id="ap_unidades_medida" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="title" class="px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="camposexcel" :name="title + '.xlsx'" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="camposLayout" :exportFields="encabezadoLayout" :name="'Layout ' + title + '.xlsx'" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>
                    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;" >

                        <v-card>
                            <v-card-title>

                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />

                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Clave" type="text" v-model="model.clave" @input="model.clave = model.clave.toUpperCase()" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex s12 m12 l12>
                                                <v-text-field label="Descripción" type="text" v-model="model.descripcion" @input="model.descripcion = model.descripcion.toUpperCase()" :rules="[rules.required]" maxlength="200" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial v-if="((id_cliente == 0 && props.row.cliente==null) || (props.row.cliente == id_cliente))" direction="left" :open-on-hover="true" >
                                        <v-btn slot="activator" x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";
import {
    Event
} from 'vue-tables-2';

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo
    },
    mounted() {},

    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],

        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,
        datos: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        tabla: 22,
        title: "UNIDADES DE MEDIDA",
        columns: ["clave", "descripcion", "clienteTipo", "actions"],
        options: {
            filterable: ["clave", "descripcion", "clienteTipo"],
            sortable: ["clave", "descripcion", "clienteTipo"],
            headings: {
                clave: "Clave",
                descripcion: "Descripción",
                clienteTipo: "Tipo",
                actions: "Operaciones"
            },
        },
        camposexcel: {
            Clave: "clave",
            "Descripción": "descripcion",
            Tipo: "clienteTipo"
        },
        encabezadoLayout: {
            clave: "clave",
            descripcion: "descripcion"
        },
        camposLayout: [{
            clave: "[Clave de la unidad de medida]",
            descripcion: "[Descripción de la unidad de medida]"
        }],
        model: {
            id: 0,
            clave: "",
            descripcion: "",
            cliente: 0,
        },
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apendices",
                disabled: true,
                to: ""
            }
        ]

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.datos.items;
            }

        },
    },
    methods: {
        render(url) {
            this.$router.push(url);
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.id_cliente;
        },

        guardar() {
            var datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            var datos = {
                cliente: this.id_cliente
            };
            axios
                .post(this.URL + "lista/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos.items = res.data;
                        for (var k in this.datos.items) {
                            this.datos.items[k].clienteTipo = (this.datos.items[k].cliente && this.datos.items[k].cliente.toString().trim() != "0") ? "Unidad de Cliente" : "Anexo 22";
                        }
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.model.cliente = (this.model.cliente == null) ? 0 : this.model.cliente;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + id_registro + "/")
                        .then(response => {
                            this.cargar();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaClave: async function (clave) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave == undefined)
                    resolve(0);

                var search = thisObject.datos.items.filter(function (e) {
                    //Si es administrador solo valida contra si mismo            
                    if (thisObject.id_cliente == 0)
                        return e.clave.toString().trim().toLowerCase() == clave.toString().trim().toLowerCase() && e.cliente == null;
                    else //Si es cliente, valida contra administrador y cliente 
                        return e.clave.toString().trim().toLowerCase() == clave.toString().trim().toLowerCase();
                });
                resolve(search.length);
            });
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    if (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length > 10) {
                        errores++;
                        erroresText += "- La clave \"" + results[k]["clave"] + "\" no debe ser mayor a 10 caracteres.<br>";
                    } else if (results[k]["clave"] == undefined || (results[k]["clave"] != undefined && results[k]["clave"].toString().trim().length == 0)) {
                        errores++;
                        erroresText += "- La clave no debe estar vacía.<br>";
                    } else if (results[k]["clave"] != undefined && await thisObject.verificaClave(results[k]["clave"]) > 0) {
                        errores++;
                        erroresText += "- La clave " + results[k]["clave"] + " ya existe.<br>";
                    }

                    if (results[k]["descripcion"] != undefined && results[k]["descripcion"].toString().trim().length > 200) {
                        errores++;
                        erroresText += "- La descripcion \"" + results[k]["descripcion"] + "\" no debe ser mayor a 200 caracteres.<br>";
                    } else if (results[k]["descripcion"] == undefined || (results[k]["descripcion"] != undefined && results[k]["descripcion"].toString().trim().length == 0)) {
                        errores++;
                        erroresText += "- La descripcion no debe estar vacía.<br>";
                    }
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise      
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            for (var k in results) {
                results[k]['cliente'] = this.id_cliente;
                //console.log("Key is " + k + ", value is" + results[k]);  
            }
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {

                    this.importData = results;
                    axios
                        .post(this.URL + "importar_unidades/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 2) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },

    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/unidades_medida/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.id_cliente = this.$local_storage.get("id_cliente");
        this.cargar();
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}

.v-text-field.v-text-field--solo .v-input__control {
    min-height: 32px !important;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>